import { render, staticRenderFns } from "./pantalla6.vue?vue&type=template&id=4a130cb5&scoped=true&"
var script = {}
import style0 from "./pantalla6.vue?vue&type=style&index=0&id=4a130cb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a130cb5",
  null
  
)

export default component.exports